import * as yup from 'yup';

export const createApiResponseSchema = <T>(schema: yup.Schema<T>) => {
  return yup.object({
    data: yup.lazy(() => schema),
    success: yup.boolean().required(),
    errorMessage: yup.string().nullable()
  });
};
